import { render, staticRenderFns } from "./HelpArea.vue?vue&type=template&id=22537b35&scoped=true"
import script from "./HelpArea.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpArea.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HelpArea.vue?vue&type=style&index=0&id=22537b35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22537b35",
  null
  
)

export default component.exports